import request from '@/router/axios';

export const getList = (page,per_page,params) => {
  return request({
    url: '/api/cube-agent/userwhkz/getCallRecord',
    method: 'get',
    params: {
      page,
      per_page,
      ...params
    }
  })
}

export const getCallRecordFile = (lyid) => {
  return request({
    url: '/api/cube-agent/userwhkz/getCallRecordFile',
    method: 'get',
    params: {
      lyid,
    }
  })
}

export const getBaseInfo = () => {
  return request({
    url: '/api/cube-agent/userwhkz/getBaseInfo',
    method: 'get',
  })
}

export const getPayRecords = (params) => {
  return request({
    url: '/api/cube-agent/userwhkz/getPayRecords',
    method: 'get',
    params: {
      ...params
    }
  })
}
